import { Close } from '@mui/icons-material'
import { Chip } from '@mui/material'
import React from 'react'
import { useStyles } from '../style'

const SkillChip = ({
  skill,
  isSelected,
  onClick,
  onDelete,
  isCustom = false,
  tabIndex = 0,
  onFocus,
  onKeyDown
}) => {
  const classes = useStyles()

  const getChipClass = () => {
    if (isCustom) {
      return classes.customItemChip
    }
    return `${classes.topicChip} ${isSelected ? 'selected' : ''}`
  }

  const handleKeyDown = (e) => {
    if (onKeyDown) {
      onKeyDown(e)
    }
  }

  return (
    <Chip
      label={skill.name}
      className={getChipClass()}
      onClick={onClick}
      onDelete={onDelete}
      onKeyDown={handleKeyDown}
      onFocus={onFocus}
      deleteIcon={onDelete ? <Close fontSize='small' /> : undefined}
      variant={isSelected && !isCustom ? 'filled' : 'outlined'}
      tabIndex={tabIndex}
      aria-label={`${skill.name}${isSelected ? ', selected' : ', not selected'}${onDelete ? ', click to remove' : ', click to select'}`}
      data-test={`skill-chip-${skill.name.replace(/\s+/g, '-').toLowerCase()}`}
    />
  )
}

export default SkillChip
